import Vue from 'vue';
import Vuex from 'vuex';

const R = require('ramda');

Vue.use(Vuex);

const state = {
  userForEdit: null,
  isLoggedIn: false,
  roles: [],
  areas: {},
  events: [],
  selectedRoleForUser: null,
  mallId: "",
  userId: "",
  usersList: [],
  popupViewName: "",
  popupPreviewName: "",
  mediaItems: [],
  mediaCategories: [],
  selectedMediaCategory: null,
  languages: [],
  selectedLanguage: {},
  selectedEvent: {},
  savedEvent: {},
  services: [],
  selectedService: {},
  savedService: {},
  categories: [],
  image: {},
  fileType: "",
  categoryModalText: {
    title: 'New Category',
    placeholder: 'CATEGORY NAME',
    saveBtn: 'CREATE'
  },
  shopModalText: {
    title: 'Add New Shop',
    name: 'Shop Name',
    categoryName: 'Shop Categories',
    logoImage: 'CLICK TO ADD SHOP LOGO',
    image: 'CLICK TO ADD SHOP IMAGE'
  },
  selectedCategory: {},
  savedCategory: {},
  savedShop: {},
  imageType: '',
  popupToOpen: '',
  selectedShop: {},
  shops: [],
  offers: [],
  selectedOffer: {},
  savedOffer: {},
  malls: [],
  selectedMall: {},
  savedMall: {},
  username: '',
  textContent: '',
  previewData: {},
  slide: {},
  selectedSlide: {},
  isLoadingSpinner: false,
  stations: [],
  savedStation: {},
  chartData: {
    statistic: {},
    chartType: '',
    dateRangeType: '',
    type: ''
  },
  garages: [],
  selectedGarage: {},
  floors: [],
  selectedFloor: {},
  isMallImage: false,
  popUpFullImg: {},
  activeRequests: 0,
  geoLocation: {}
};

const mutations = {
  addRequest(state) {
    state.activeRequests = state.activeRequests + 1;
  },
  removeRequest(state) {
    if (state.activeRequests > 0) {
      state.activeRequests = state.activeRequests - 1;
    }
  },
  setFullImg(state, item) {
    state.popUpFullImg = item;
  },
  setGarages(state, garages) {
    state.garages = garages;
  },
  setMallImage(state, data) {
    state.isMallImage = data;
  },
  editGarage(state, garage) {
    state.garages = state.garages.map(item => {
      if (item.id === garage.id) { item = garage }
      return item;
    });
  },
  removeGarage(state, garage) {
    state.garages = state.garages.filter(item => item.id !== garage.id);
  },
  pushGarage(state, garage) {
    state.garages.push(garage);
  },
  setGarage(state, garage) {
    state.selectedGarage = garage;
  },
  setFloors(state, floors) {
    state.floors = floors;
  },
  editFloor(state, floor) {
    state.floors = state.floors.map(item => {
      if (item.id === floor.id) { item = floor }
      return item;
    });
  },
  removeFloor(state, floor) {
    state.floors = state.floors.filter(item => item.id !== floor.id);
  },
  pushFloor(state, floor) {
    state.floors.push(floor);
  },
  setFloor(state, floor) {
    state.selectedFloor = floor;
  },
  setChartData(state, data) {
    state.chartData = data;
  },
  pushToStations(state, station) {
    state.stations.push(station);
  },
  setStationForEdit(state, station) {
    state.savedStation = station;
  },
  setStations(state, stations) {
    state.stations = stations;
  },

  showLoader(state, show) {
    state.isLoadingSpinner = show;
  },

  setSlide(state, slide) {
    state.selectedSlide = slide;
  },
  setSlideName(state, data) {
    state.slide = {
      name: data.name,
      startDate: data.startDate,
      endDate: data.endDate,
      index: data.index
    };
  },
  setPreviewData(state, data) {
    state.previewData = data;
  },
  setTextContent(state, content) {
    state.textContent = content;
  },
  setFileType(state, type) {
    state.fileType = type;
  },
  setMalls(state, malls) {
    state.malls = malls;
  },
  setMallForEdit(state, mall) {
    state.selectedMall = mall;
  },
  saveMall(state, mall) {
    state.savedMall = mall;
  },
  addMall(state, mall) {
    state.malls.push(mall);
  },
  updateMall(state, mall) {
    state.malls = state.malls.map(item => {
      if (item.id === mall.id) { item = mall }
      return item;
    });
  },
  deleteMall(state, mall) {
    state.malls = state.malls.filter(item => item.id !== mall.id);
  },
  setUserForEdit(state, user) {
    state.userForEdit = user;
  },
  cleanUserForEdit(state, user) {
    state.userForEdit = null;
  },
  setMediaCategory(state, item) {
    state.selectedMediaCategory = item;
  },
  cleanMediaCategory(state) {
    state.selectedMediaCategory = null;
  },
  setSelectedLanguage(state, language) {
    state.selectedLanguage = language;
  },
  setLanguages(state, languages) {
    state.languages = languages;
  },
  setAreas(state, areas) {
    state.areas = areas;
  },
  setMediaItems(state, mediaItems) {
    state.mediaItems = mediaItems;
  },
  removeMediaItem(state, mediaItems) {
    state.mediaItems = state.mediaItems.filter(el => {
      const finded = mediaItems.find(item => item.id === el.id);
      return !finded;
    });
  },
  appendMediaItems(state, mediaItems) {
    state.mediaItems = R.concat(state.mediaItems, mediaItems);
  },
  addMediaCategory(state, item) {
    state.mediaCategories.push(item);
  },
  setMediaCategories(state, items) {
    state.mediaCategories = items;
  },
  setRoleForUser(state, roleName) {
    state.selectedRoleForUser = roleName;
  },
  setMallId(state, mallId) {
    state.mallId = mallId;
  },
  login(state, username) {
    state.isLoggedIn = true;
    state.username = username;
  },
  logout(state) {
    state.isLoggedIn = false;
    state.username = "";
  },
  setUsers(state, users) {
    state.usersList = users;
  },
  setUserId(state, userId) {
    state.userId = userId;
  },
  deleteUserById(state, userId) {
    state.usersList = R.filter((u) => u.id !== userId, state.usersList);
  },
  pushToUsers(state, user) {
    state.usersList.push(user);
  },
  updateUser(state, user) {
    state.usersList = R.filter((u) => u.id !== user.id, state.usersList);
    state.usersList.push(user);
  },
  setRoles(state, roles) {
    state.roles = roles;
  },
  updateRole(state, role) {
    const updatedRoles = R.map(r => r.id === role.id ? role : r, state.roles);
    state.roles = updatedRoles;
  },
  deleteRoleById(state, roleId) {
    state.roles = R.filter((r) => r.id !== roleId, state.roles);
  },
  pushToRoles(state, role) {
    state.roles.push(role);
  },
  setEvents(state, events) {
    state.events = events;
  },
  pushToEvents(state, event) {
    state.events.push(event);
  },
  showPopup(state, view) {
    if (state.popupViewName === 'edit-shop') {
      document.querySelector(".google-map").appendChild(document.getElementById("location-input"));
      document.querySelector(".google-map").appendChild(document.getElementById("gmp-map"));
    }
    state.popupViewName = view;
  },
  showPreviewPopup(state, view) {
    state.popupPreviewName = view;
  },
  cleanSelectedEvent(state) {
    state.selectedEvent = {};
  },
  hidePopup(state) {
    if (state.popupViewName === 'edit-shop') {
      document.querySelector(".google-map").appendChild(document.getElementById("location-input"));
      document.querySelector(".google-map").appendChild(document.getElementById("gmp-map"));
    }
    state.popupViewName = "";
  },
  hidePreviewPopup(state) {
    state.popupPreviewName = "";
  },
  editEvent(state, event) {
    state.popupViewName = "events-edit-popup";
    state.selectedEvent = event;
  },
  updateEvent(state, event) {
    state.events = R.map(item => item.id === event.id ? event : item, state.events);
  },
  openDeletePopup(state, event) {
    state.popupViewName = "delete-popup";
    state.selectedEvent = event;
  },
  removeEvent(state, event) {
    state.events = R.filter((item) => item.id !== event.id, state.events);
  },
  saveEvent(state, event) {
    state.savedEvent = event;
  },
  selectEvent(state, event) {
    state.selectedEvent = event;
  },
  setImage(state, image) {
    state.image = image;
  },
  setCategories(state, categories) {
    state.categories = categories;
  },
  setServices(state, services) {
    state.services = services;
  },
  setService(state, service) {
    state.selectedService = service;
  },
  removeService(state, service) {
    state.services = state.services.filter(item => item.id !== service.id);
  },
  saveService(state, service) {
    state.savedService = service;
  },
  pushService(state, service) {
    state.services.push(service);
  },
  editService(state, service) {
    state.services = state.services.map(item => {
      if (item.id === service.id) { item = service }
      return item;
    });
  },
  setCategory(state, category) {
    state.selectedCategory = category;
  },
  saveCategory(state, category) {
    state.savedCategory = category;
  },
  pushToCategories(state, category) {
    state.categories.push(category);
  },
  changeCategoryText(state, newText) {
    state.categoryModalText = newText;
  },
  updateCategory(state, category) {
    state.categories = state.categories.map(cat => cat.id === category.id ? category : cat);
  },
  removeCategory(state, category) {
    state.categories = state.categories.filter(item => item.id !== category.id);
  },
  saveShop(state, shop) {
    state.savedShop = shop;
  },
  imageType(state, type) {
    state.imageType = type;
  },
  popupToOpen(state, name) {
    state.popupToOpen = name;
  },
  cleanSelectedShop(state) {
    state.selectedShop = {};
  },
  setShops(state, shops) {
    state.shops = shops;
  },
  pushToShops(state, shop) {
    state.shops.push({ shop });
  },
  pushToShopsList(state, shop) {
    state.shops.push({ ...shop });
  },
  changeShopModalText(state, text) {
    state.shopModalText = text;
  },
  setShop(state, shop) {
    state.selectedShop = shop;
  },
  updateShop(state, shop) {
    state.shops = state.shops.map(el => {
      if (el.shop ? el.shop.id === shop.id : el.id === shop.id) { el.shop ? el.shop = shop : el = shop }
      return el;
    });
  },
  removeShop(state, shop) {
    state.shops = state.shops.filter(el => el.shop.id !== shop.id);
  },
  removeFromShops(state, shop) {
    state.shops = state.shops.filter(el => el.id !== shop.id);
  },
  setOffers(state, offers) {
    state.offers = offers;
  },
  setOffer(state, offer) {
    state.selectedOffer = offer;
  },
  saveOffer(state, offer) {
    state.savedOffer = offer;
  },
  removeOffer(state, offer) {
    state.offers = state.offers.filter(el => el.id !== offer.id);
  },
  addOffer(state, offer) {
    state.offers.push(offer);
  },
  updateOffer(state, offer) {
    state.offers = state.offers.map(el => {
      if (el.id === offer.id) { el = offer }
      return el;
    });
  },
  geoLocation(state, payload) {
    state.geoLocation = payload;
  }
};

export default new Vuex.Store({
  state,
  mutations
});
